"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var MAX_FILTERS = 4;
var TableRow = function (_a) {
    var index = _a.index, onRemove = _a.onRemove, filters = _a.filters, navigateToSearch = _a.navigateToSearch;
    var t = react_i18next_1.useTranslation('common').t;
    var _b = react_1.useState(false), isExpanded = _b[0], setIsExpanded = _b[1];
    var handleToggle = function () { return setIsExpanded(!isExpanded); };
    var hiddenCount = function () {
        return Math.max(filters.length - MAX_FILTERS, 0);
    };
    var summaryText = function () {
        if (isExpanded) {
            return filters.join('/');
        }
        return filters.slice(0, MAX_FILTERS).join('/');
    };
    return (react_1.default.createElement(semantic_ui_react_1.Table.Row, { className: styles_module_scss_1.default.search_row },
        react_1.default.createElement(semantic_ui_react_1.Table.Cell, { onClick: function () { return navigateToSearch(Number(index)); }, className: styles_module_scss_1.default.search_name },
            t('Account.SAVED_SEARCH.MY_SEARCH'),
            " - ",
            index + 1),
        react_1.default.createElement(semantic_ui_react_1.Table.Cell, { className: styles_module_scss_1.default.cursor_pointer, onClick: handleToggle },
            summaryText(),
            ' ',
            !isExpanded && hiddenCount() > 0 && (react_1.default.createElement("span", { className: styles_module_scss_1.default.expand },
                " +",
                hiddenCount()))),
        react_1.default.createElement(semantic_ui_react_1.Table.Cell, { className: styles_module_scss_1.default.remove_search },
            react_1.default.createElement("div", { className: "remove-icon w-30", onClick: function () { return onRemove(Number(index)); } },
                react_1.default.createElement("i", { className: classnames_1.default('cm-icon icon-ic-remove', styles_module_scss_1.default.cursor_pointer) })))));
};
exports.default = TableRow;
